import { Link } from 'react-router-dom';
import { UserRole } from '@wineryxplorer/shared';
import { FormSection } from '../../components/ui/FormSection';

interface AssignedVenue {
  _id: string;
  name: string;
}

interface AdminUserAccountInfoProps {
  userId: string;
  role: UserRole;
  createdAt: string | Date;
  updatedAt: string | Date;
  assignedVenues: AssignedVenue[];
}

export const AdminUserAccountInfo = ({
  userId,
  role,
  createdAt,
  updatedAt,
  assignedVenues,
}: AdminUserAccountInfoProps) => (
  <>
    {/* Metadata */}
    <FormSection title="Account Info" titleAs="h3">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
        <div>
          <span className="text-gray-500">Joined:</span>{' '}
          <span className="text-gray-900">{new Date(createdAt).toLocaleDateString()}</span>
        </div>
        <div>
          <span className="text-gray-500">Last Updated:</span>{' '}
          <span className="text-gray-900">{new Date(updatedAt).toLocaleDateString()}</span>
        </div>
        <div>
          <span className="text-gray-500">User ID:</span>{' '}
          <span className="text-gray-900 font-mono text-xs">{userId}</span>
        </div>
      </div>
    </FormSection>

    {/* Assigned venues for VENUE_ADMIN */}
    {role === UserRole.VENUE_ADMIN && assignedVenues.length > 0 && (
      <FormSection title="Assigned Venues" titleAs="h3" contentClassName="space-y-2">
        <div className="space-y-2">
          {assignedVenues.map((venue) => (
            <Link
              key={venue._id}
              to={`/venues/${venue._id}`}
              className="block text-sm text-primary-600 hover:text-primary-800 hover:underline"
            >
              {venue.name}
            </Link>
          ))}
        </div>
      </FormSection>
    )}

    {role === UserRole.VENUE_ADMIN && assignedVenues.length === 0 && (
      <FormSection title="Assigned Venues" titleAs="h3">
        <p className="text-sm text-gray-500">No venues assigned to this user.</p>
      </FormSection>
    )}
  </>
);
